import React from 'react';
import OrdersList from './OrdersList';

// Este componente serve como ponto de entrada para a rota /orders
// Simplesmente renderiza o componente OrdersList

const OrdersListPage = () => {
  return <OrdersList />;
};

export default OrdersListPage;